export default __webpack_public_path__ + "static/media/vcard.2d79b962.svg";